<template>
    <div class="files_block">
        
        <div class="add_file">
            <fileloader
                
                key="file_loader_mem"
                doc_type="memorandum"
                :doc_id="get_doc_id"
                v-if="can_add"
                v-bind:trigger_load="file_triger"
                v-bind:can_del="true"
            >
            </fileloader>
        </div>
        
        <!--
        <div class="adv mt-3 mb-3 text-right" v-if="files.length > 0">
            <span class="badge badge-warning">Завантажити всі  -> </span>
            <a class="btn btn-primary btn-lg text-white btn-icon hover-effect-dot waves-effect waves-themed" target="_blank" :href="get_all_files_url" >
                <i class="fal fa-download"></i>
            </a>
        </div>
        -->
        
        
        <b-table class="table-responsive-lg"    :thead-class="head_class"  striped  :items="files" :fields="fields">
            
            <template  v-slot:head(link)="data">
                <span class="fs-xl text-center" v-html="data.label"></span>
            </template>
            
            <template v-slot:head(remove)="data">
                <span class="fs-xl text-center" v-html="data.label"></span>
            </template>
            
            <template  v-slot:cell(link)="data" >
                <span class="get_file cursor-pointer" @click="get_file(data.item)">
                     <i class="fal  fa-save save_me"></i>
                </span>
            </template>
            
            <template  v-slot:cell(remove)="data" >
                <i class="fas fa-trash fs-xl" @click="remove_item(data.item)" ></i>
            </template>
        
        </b-table>
    </div>
</template>

<script>
import fileloader from "../../../../../../shared/file_loader/fileloader.vue";

export default {
    name: "tab_files",
    
    components : {
        fileloader
    },
    
    props: {
        doc_id: {
            type: Number,
            required: true
        },
        
        file_triger: {
            type: String,
            default: "mem_file_add_inside_files",
        }
    },
    
    data() {
        return {
            
            fields: [
                {
                    key: 'id',
                    label: 'ID',
                    sortable: true
                },
                {
                    key: 'name',
                    label: 'Назва',
                    sortable: true
                },
                {
                    key: 'user_small',
                    label: 'ПIБ',
                    sortable: true
                },
                {
                    key: 'added_human',
                    label: 'Дата',
                    sortable: true
                },
                {
                    key : 'link',
                    label: '<i class="fal fa-save"></i>',
                    sortable: false
                },
                {
                    key : 'remove',
                    label: '<i class="fal fa-trash"></i>',
                    sortable: false
                },
            
            ],
            files: [],
            cur_right : '',
        }
    },
    
    created() {
        
        EventBus.$on('refresh_tabs', e => {
            console.log('REFRESH_CALLED', e);
            this.refresh_tab(e);
        });
        
        
        EventBus.$on(this.file_triger, e => {
            console.log('FILE_ACTION', e);
            this.getFiles();
        });
        
        this.getFiles();
    },
    
    computed: {
        can_add () {
            
            if (this.cur_right === 'active vip_user') {
                return true;
            }
            
            if (this.cur_right === 'active land_user') {
                return true;
            }
            
            if (this.cur_right === 'active') {
                return true;
            }
            
            return false;
        },
        
        get_doc_id () {
            return this.doc_id;
        },
        
        get_all_files_url() {
            return "/docs/internal/memorandum/files_zip?doc_id=" + this.get_doc_id;
        },
        
        
   
        
        head_class() {
            // if(!this.show_head) {
            return 'bg-primary text-white';
            // }
        }
    },
    
    methods: {
        show_loading(flag) {
            this.$store.dispatch('memorandum_work_tabs/SET_MEM_LOAD_TAB', {
                type: this.$options.name,
                active: flag
            });
        },
        
        async remove_item (item) {
            const is_ok = confirm_imc('Виконати ?');
            is_ok.then(res => {
                this.show_loading(true);
                
                api.delete('/files/' + item.id).then(({data}) => {
                    if (data.status === "operation_success") {
                        this.getFiles();
                    }
                    this.show_loading(false);
                }).catch(err => {
                    this.show_loading(false);
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
                });
            });
            
        },
        
        get_file(item) {
            this.show_loading(true);
            
            
            api.get('/files/' + item.id, { responseType: 'blob' }) // responseType важен!
                .then(response => {
                    if (response.status === 200) {
                        this.show_loading(false);
                        const fileType = response.headers['content-type'] || '';
                        const fileBlob = new Blob([response.data], { type: fileType });
                        const fileURL = window.URL.createObjectURL(fileBlob);
                        
                        if (fileType.includes('pdf') || item.name.toLowerCase().endsWith('.pdf')) {
                            window.open(fileURL, '_blank');
                        } else {
                            const fileLink = document.createElement('a');
                            fileLink.href = fileURL;
                            fileLink.setAttribute('download', item.name);
                            document.body.appendChild(fileLink);
                            fileLink.click();
                            document.body.removeChild(fileLink);
                        }
                    } else {
                        EventBus.$emit('show_toast', { err: 'File not found', type: "danger", title: 'Error' });
                    }
                })
                .catch(err => {
                    EventBus.$emit('show_toast', { err: err.message, type: "danger", title: err.name });
                })
                .finally(() => {
                });
        },
        
        
        refresh_tab (e) {
            if(e.tabs.length > 0) {
                let self = this;
                e.tabs.forEach(tab => {
                    if(tab === this.$options.name) {
                        self.getFiles();
                    }
                })
            }
        },
        async getFiles() {
            
            this.show_loading(true);
            await api.get('/memorandums/'+ this.doc_id +'/files').then(({data}) => {
                if (data.status === "operation_success") {
                    this.files = data.data;
                    this.cur_right = data.message.can_add.rights;
                    
                    this.$store.dispatch('memorandum_work_tabs/SET_MEM_TAB_COUNT', {
                        type: this.$options.name,
                        count: this.files.length,
                    });
                    
                    this.show_loading(false);
                }
            }).catch(err => {
                this.show_loading(false);
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
            });
            
        },
        
    },
}
</script>

<style scoped>
.save_me {
    font-size:16px;
    color:#0056b3;
}
.save_me:hover {
    color:black;
}

.fa-trash {
    font-size: 16px;
    color: red;
    cursor: pointer;
}

</style>
